Comparison of the errors thrown by libraries, including stack trace length.

```ts
import { personSchema } from "./schemas";
import * as v from "valibot";

try {
  v.parse(personSchema, data);
} catch (e) {
  console.error(e);
}
```

Where `error.stack` is available, we measure how many frames it takes to reach the line of user code (as opposed to library code).
